import React from 'react';
import { MediaAssetsDisplay } from './MediaAssetsDisplay';
import { IContentImageUpload } from '../types';

interface IMediaAssetsSectionProps {
  uploads: IContentImageUpload[];
  isCreateMode?: boolean;
  onAddPhoto: (file: File, displayName: string) => Promise<void>;
  onDeletePhoto: (index: number) => void;
  onImageClick?: (index: number) => void;
}

export const MediaAssetsSection = ({
  uploads,
  isCreateMode = false,
  onAddPhoto,
  onDeletePhoto,
  onImageClick,
}: IMediaAssetsSectionProps) => {
  return (
    <div className="space-y-[10px]">
      {/* Section Title */}
      <span className="font-bold text-[17px] text-gray-800 font-pt-sans">Media Assets</span>

      {/* Media Assets Display */}
      <MediaAssetsDisplay
        uploads={uploads}
        isCreateMode={isCreateMode}
        onAddPhoto={onAddPhoto}
        onDeletePhoto={onDeletePhoto}
        onImageClick={onImageClick}
      />
    </div>
  );
};